<mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()" 
    (click)="$event.stopPropagation()" (change)="toggleSelection($event)" color="primary">
    {{'common.select-all' | translate}}
</mat-checkbox>